import { AitRowData } from "aic";
import { hasStylesInCell } from "./hasStylesInCell";

/**
 * Checks if a table row contains any Optional or Notes styles.
 * Checks all cells in the row.
 *
 * @template T - Content type for row cells
 * @param row - The row to check for styles
 * @returns True if any cell contains styles to remove, false otherwise
 */
export const hasStylesInRow = <T>(row: AitRowData<T>): boolean => {
  return row.cells.some((cell) => hasStylesInCell(cell));
};
